import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {applyPageMeta, PageMeta} from './meta';

/** Sets title, description, canonical address, preview image and structured data of the current page. */
export function usePageMeta(meta: PageMeta) {
    const {pathname} = useLocation();
    // serialised, so the effect only runs when the values change, not on every new object
    const key = JSON.stringify({...meta, path: meta.path ?? pathname});

    useEffect(() => {
        applyPageMeta(JSON.parse(key));
    }, [key]);
}
